<section class="merge-dialog">
  <h2>Объединение дублей товара</h2>
  <p class="hint">
    Данные дублей будут перенесены в основную карточку. После объединения дубли
    будут удалены.
  </p>
  <div class="source-card" *ngIf="!hasMultipleCandidates && product">
    <span class="caption">Дубль для переноса и удаления</span>
    <strong
      >#{{ product.id }} · {{ product.brand?.description }}
      {{ product.article }}</strong
    >
    <span>{{ product.description }}</span>
  </div>
  <div class="search-row">
    <mat-form-field appearance="outline">
      <mat-label>Найти основную карточку</mat-label>
      <input
        matInput
        [formControl]="searchControl"
        placeholder="Артикул, название или ID"
        (keydown.enter)="$event.preventDefault(); search()"
      />
    </mat-form-field>
    <button
      mat-stroked-button
      type="button"
      (click)="search()"
      [disabled]="loading || searching"
    >
      {{ searching ? "Поиск…" : "Найти" }}
    </button>
  </div>
  <p class="hint" *ngIf="searchError">{{ searchError }}</p>
  <div class="results" *ngIf="results.length">
    <button
      type="button"
      class="result"
      *ngFor="let card of results"
      (click)="choose(card)"
      [disabled]="loading"
    >
      <strong>#{{ card.id }} · {{ card.brand }} {{ card.article }}</strong>
      <span>{{ card.description }}</span>
      <small
        >Остаток: {{ card.stock }} · Розница:
        {{ card.retail | number: "1.2-2" }} грн.</small
      >
    </button>
  </div>
  <form (ngSubmit)="check()">
    <mat-form-field appearance="outline">
      <mat-label>Основной ID — эта карточка останется</mat-label>
      <input matInput type="number" min="1" [formControl]="idControl" />
    </mat-form-field>
    <div class="merge-candidates" *ngIf="hasMultipleCandidates">
      <strong>Дубли для переноса и удаления</strong>
      <mat-checkbox
        *ngFor="let candidate of mergeCandidates"
        [checked]="
          isCandidateSelected(candidate.id) && candidate.id !== normalizedMainId
        "
        [disabled]="loading || candidate.id === normalizedMainId"
        (change)="toggleCandidate(candidate.id, $event.checked)"
      >
        #{{ candidate.id }} {{ candidate.brand?.description }}
        {{ candidate.article }} · {{ candidate.description }}
      </mat-checkbox>
    </div>
    <mat-checkbox *ngIf="!hasMultipleCandidates" [formControl]="newPriceControl"
      >Взять закупочную и розничную цены из дубля</mat-checkbox
    >
    <mat-checkbox *ngIf="!hasMultipleCandidates" [formControl]="saveDescription"
      >Взять наименование из дубля</mat-checkbox
    >
    <mat-form-field appearance="outline">
      <mat-label>Причина объединения</mat-label>
      <input matInput maxlength="500" [formControl]="reasonControl" />
    </mat-form-field>
    <button
      mat-stroked-button
      color="primary"
      type="submit"
      [disabled]="loading"
    >
      Проверить слияние
    </button>
  </form>
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  <p class="error" role="alert" *ngIf="error">{{ error }}</p>
  <section
    class="preview"
    *ngIf="preview as p"
    aria-label="Результат проверки слияния"
  >
    <div class="main-card">
      <span class="caption">Останется основная карточка</span>
      <strong
        >#{{ p.main.id }} · {{ p.main.brand }} {{ p.main.article }}</strong
      >
      <span>{{ p.resultingDescription }}</span>
      <span
        >Общий остаток: {{ p.resultingStock }} · Закупка:
        {{ p.resultingPrice | number: "1.2-2" }} грн. · Розница:
        {{ p.resultingRetail | number: "1.2-2" }} грн.</span
      >
    </div>
    <div class="source-card" *ngFor="let source of p.sources">
      <span class="caption">Будет удалён после переноса</span>
      <strong
        >#{{ source.id }} · {{ source.brand }} {{ source.article }}</strong
      >
      <span>{{ source.description }} · Остаток: {{ source.stock }}</span>
      <small *ngIf="source.barcodes.length"
        >Штрихкоды: {{ source.barcodes.join(", ") }}</small
      >
    </div>
    <div class="impacts" *ngIf="p.impacts.length">
      <span *ngFor="let impact of p.impacts"
        >{{ impact.label }}: <b>{{ impact.count }}</b></span
      >
    </div>
    <p class="warning" *ngFor="let warning of p.warnings">{{ warning }}</p>
    <p class="error" *ngFor="let blocker of p.blockers">{{ blocker }}</p>
    <ng-container *ngIf="!p.blockers.length">
      <mat-checkbox
        class="confirmation"
        [formControl]="identityControl"
        [disabled]="loading"
        >Подтверждаю: это один и тот же товар. Данные нужно объединить, а
        карточки дублей удалить.</mat-checkbox
      >
      <p class="hint">
        Операция сохранится в истории. Автоматической отмены слияния нет.
      </p>
    </ng-container>
  </section>
  <div class="actions">
    <button mat-button type="button" (click)="cancel()" [disabled]="loading">
      Закрыть
    </button>
    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="send()"
      [disabled]="
        loading ||
        !preview ||
        !!preview.blockers.length ||
        !identityControl.value
      "
    >
      {{ loading ? "Проверка и перенос…" : "Объединить и удалить дубли" }}
    </button>
  </div>
</section>
